import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DataContainer from 'Components/UI/DataContainer';

import ClientAgreementContent from './ClientAgreementContent';
import { useClientAgreementContext } from './ClientAgreementContext';


const styles = () => ({
  root: {},
});

const ClientAgreementContainer = ({
  className,
  classes,
}) => {
  const {
    isInitializing,
    initializingError,
  } = useClientAgreementContext();

  return (
    <DataContainer
      className={classes.container}
      component={ClientAgreementContent}
      componentProps={{
        className: classNames(classes.root, className),
      }}
      loading={isInitializing}
      loadingError={initializingError}
      ErrorListProps={{
        title: 'An error occurred loading your Facet membership agreement.',
      }}
    />
  );
};

ClientAgreementContainer.defaultProps = {
  className: '',
};

ClientAgreementContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClientAgreementContainer);
